export default function DotsIcon() {
    return  <svg xmlns="http://www.w3.org/2000/svg" width="4" height="20" viewBox="0 0 4 20" fill="none">
                <circle cx="1.579" cy="1.579" r="1.579" transform="matrix(-1 0 0 1 3.156 0)" fill="#7E7E7E"/>
                <circle cx="1.579" cy="1.579" r="1.579" transform="matrix(-1 0 0 1 3.156 8.421)" fill="#7E7E7E"/>
                <circle cx="1.579" cy="1.579" r="1.579" transform="matrix(-1 0 0 1 3.156 16.842)" fill="#7E7E7E"/>
            </svg>
}